import { render, staticRenderFns } from "./FirstExaminer.vue?vue&type=template&id=0fee1a3b&scoped=true&"
import script from "./FirstExaminer.vue?vue&type=script&lang=js&"
export * from "./FirstExaminer.vue?vue&type=script&lang=js&"
import style0 from "./FirstExaminer.vue?vue&type=style&index=0&id=0fee1a3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fee1a3b",
  null
  
)

export default component.exports